/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Bright_Warm_Gibbon_RenewInputs */

const fr_bright_warm_gibbon_renew = /** @type {(inputs: Bright_Warm_Gibbon_RenewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Programme`)
};

/**

* @param {Bright_Warm_Gibbon_RenewInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const bright_warm_gibbon_renew = /** @type {((inputs?: Bright_Warm_Gibbon_RenewInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Bright_Warm_Gibbon_RenewInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_bright_warm_gibbon_renew(inputs)
});